import { render, staticRenderFns } from "./userWalletCashToexamine.vue?vue&type=template&id=5f136e52&scoped=true&"
import script from "./userWalletCashToexamine.vue?vue&type=script&lang=js&"
export * from "./userWalletCashToexamine.vue?vue&type=script&lang=js&"
import style0 from "./userWalletCashToexamine.vue?vue&type=style&index=0&id=5f136e52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f136e52",
  null
  
)

export default component.exports